import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#f4ecdf",
            border: "1px solid rgba(26,20,16,0.2)",
            color: "#1a1410",
            borderRadius: 0,
            fontFamily: "'Inter', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
